module.exports = __webpack_public_path__ + "assets/fonts/ProximaNova-Light.5940d76f.woff";